import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Backdrop,
  CircularProgress,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { ArrowLeft, Check, Edit } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { QuestionCircleFill } from "react-bootstrap-icons";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { useRoutingByType } from "../../controllers/useRouting";
import { useLastRoute } from "../../controllers/LastRouteContext";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import NoDataFound from "../Main/NoDataFound";
import Notification from "../Notification";
import { InputComponent, ButtonComponent, SelectComponent, DetailsComponent, RichTextEditor } from '@shopeasy-dashboard-ui/ui-library';
import AiTextGenerate from "../AiTextGenerate";

function UpdatePortfolioCategory() {
  const params = useParams();
  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);
  const [slugEdited, setSlugEdited] = useState(false);
  const [slugField, setSlugField] = useState(false);
  const [slugName, setSlugName] = useState();

  const handleSlug = async (slug) => {
    if (slug?.length) {
      setSlugField(true);
      setSlugName(await GenerateSlugName(slug));
    } else {
      setSlugName("");
    }
  };
  const [nodata, setNodata] = useState(false);
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [SelectedPortfolioParentCategory, setSelectedPortfolioParentCategory] = useState();
  const [PortfolioCatData, setPortfolioCatData] = useState({
    _id: "",
    portfoliocategory_name: "",
    meta_tag_title: "",
    meta_tag_description: "",
    keyword: "",
  });
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const protocol = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'http://' : 'https://';
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [description, setDescription] = useState();
  const [isChange, setIsChange] = useState(false);
  const [portfolioCatId, setPortfolioCatId] = useState();
  const [formSpinner, setFormSpinner] = useState(true);
  const clientInfo = clientData;
  const lastRoute = useLastRoute();
  const portfolioRoute = useRoutingByType("portfolio");

  const GetPortfolioCategoryById = async () => {
    setFormSpinner(true);
    try {
      const ApiCall = await API({
        url: `/admin/portfoliocategory/getPortfolioCategory/${params.portfoliocatid}`,
        method: "get",
      });
      const result = ApiCall?.data;
      setPortfolioCatId(result?.data);
      setSelectedPortfolioParentCategory(result?.data?.parent_portfoliocategory?._id || result?.data?.parent_portfoliocategory);
      setPortfolioCatData({
        _id: result?.data?._id ? `${result?.data?._id}` : "",
        portfoliocategory_name: result?.data?.portfoliocategory_name
          ? `${result?.data?.portfoliocategory_name}`
          : "",
        meta_tag_title: result?.data?.meta_tag_title ? `${result?.data?.meta_tag_title}` : "",
        meta_tag_description: result?.data?.meta_tag_description
          ? `${result?.data?.meta_tag_description}`
          : "",
        keyword: result?.data?.keyword ? `${result?.data?.keyword}` : "",
      });
      setIsMetaTitleCustom(Boolean(result?.data?.meta_tag_title));
      setSlugName(
        result?.data?.portfolio_category_slug_name
          ? result?.data?.portfolio_category_slug_name
          : "",
      );
      setSlugEdited(Boolean(result?.data?.portfolio_category_slug_name));
      setDescription(result?.data?.description);
      setFormSpinner(false);
    } catch (error) {
      setNodata(true);
      console.log(error);
    }
  };

  const { portfoliocategory_name, meta_tag_title, meta_tag_description, keyword } =
    PortfolioCatData;

  const HandleInput = (e) => {
    setIsChange(true);
    if (e.target.name === "meta_tag_title") {
      setIsMetaTitleCustom(Boolean(e.target.value));
    }
    setPortfolioCatData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const [ParentCategory, setParentCategory] = useState([]);
  const GetParentCategory = async () => {
    try {
      const data = await API({
        url: `/admin/portfoliocategory/GetPortfolioCategoriesWithParent?default=true`,
        method: "get",
        params: { limit: "all" },
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        const filterCategory = result?.data?.records?.filter(
          (x) => x._id !== PortfolioCatData?._id,
        );
        setParentCategory(filterCategory || []);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    GetParentCategory();
  }, [PortfolioCatData._id]);

  useEffect(() => {
    GetPortfolioCategoryById();
  }, []);

  const [err, setErr] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    let body = {
      ...PortfolioCatData,
      description: description,
    };
    if (SelectedPortfolioParentCategory?.length > 0) {
      body = {
        ...body,
        parent_portfoliocategory: SelectedPortfolioParentCategory,
      };
    }
    if (slugEdited && slugName) {
      body = {
        ...body,
        portfolio_category_slug_name: slugName,
      };
    }

    try {
      const payload = body;
      const data = await API({
        url: `/admin/portfoliocategory/updatePortfolioCategory/${PortfolioCatData._id}`,
        method: "put",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        setIsNotification(true);
        setNotificationMsg("Portfolio Category Updated Successfully");
        setSeverity("success");
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: lastRoute,
          title: "add portfolio category",
        });
        parentNavigate(lastRoute);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const [AiLoader, setAiloader] = useState(false);

  const generateMetaData = async (data, key) => {
    if (description?.length === 0) {
      setIsNotification(true);
      setNotificationMsg("Please enter description!");
      setSeverity("error");
    } else {
      try {
        setAiloader(true);
        const payload = { name: data };
        if (key === "description") {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_description",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setPortfolioCatData({
            ...PortfolioCatData,
            meta_tag_description: result?.data,
          });
        } else {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_title",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setIsMetaTitleCustom(true);
          setPortfolioCatData((prev) => ({ ...prev, meta_tag_title: result?.data }));
        }
        setIsChange(true);
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };

  const handleQuillChange = (value) => {
    setDescription(value);
    setIsChange(true);
  };

  const [html, setHtml] = useState({ htmlPP: false, code: "" });
  const saveHTML = (value) => {
    setHtml({ ...html, htmlPP: false });
    setDescription(value);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };

  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: lastRoute,
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "edit portfolio category",
      });
    } else {
      setSaveChanges({
        backLink: lastRoute,
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "edit portfolio category",
      });
    }
  }, [isChange]);

  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: lastRoute,
        title: "edit portfolio category",
      });
    } else {
      parentNavigate(lastRoute);
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_ai_generate_content_loader")}</p>
        </Backdrop>
      )}

      {nodata ? (
        <NoDataFound />
      ) : (
        <div className="h-auto overflow-y-auto pb-[130px] pt-5">
          <div className="px-[20px]">
            <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
              <div className="flex items-center space-x-2">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    checkChanges();
                  }}
                  className="back-arrow -ml-3.5"
                >
                  <ArrowLeft />
                </button>
                <div className="flex-1 min-w-0">
                  <Breadcrumbs
                    crumbs={[
                      { name: t("lang_Portfolio_Categories"), path: lastRoute },
                      {
                        name: t("lang_Update_Portfolio_Category"),
                        path: "/portfolio/categories/edit-portfolio-category",
                      },
                    ]}
                  />
                  <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                    <h4 className="text-xl md:text-2xl font-semibold text-primary">
                      {t("lang_Update_Portfolio_Category")} - {portfolioCatId?.portfoliocategory_name}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-[20px]">

            {formSpinner ? (
              <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
                <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                  <div className="flex items-center space-x-4 w-full">
                    <div className="w-full">
                      <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                      <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                    </div>
                    <div className="w-full">
                      <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                      <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                    </div>
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[200px]" variant="rounded-[6px]" />
                  </div>
                </div>
              </div>
            ) : (
              <form
                onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                method="POST"
                className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
              >
                <DetailsComponent
                  open={true}
                  hasHr={false}
                  showChevron={false}
                  className="!pt-5 sm:!pt-[25px]"
                >
                  <div className="w-full mb-4">
                    <label htmlFor="portfoliocategory_name" className="flex items-center justify-between">
                      <p className="text-[13px]">
                        {t("lang_Portfolio_Category_Name")}
                        <span className="text-red-500 ms-1">*</span>
                      </p>
                    </label>
                    <InputComponent
                      id="portfoliocategory_name"
                      name="portfoliocategory_name"
                      value={portfoliocategory_name}
                      onChange={(e) => {
                        const newName = e.target.value;
                        setErr(false);
                        setIsChange(true);
                        if (!enableSlug && (!slugEdited || !slugName)) handleSlug(newName);
                        const shouldSyncMeta = !isMetaTitleCustom;
                        setPortfolioCatData((prev) => ({
                          ...prev,
                          portfoliocategory_name: newName,
                          ...(shouldSyncMeta ? { meta_tag_title: newName } : {}),
                        }));
                      }}
                      placeholder="e.g. Tech"
                      error={err && portfoliocategory_name?.length === 0 ? t("lang_Please_Enter_Portfolio_Category") : ""}
                      onBlur={() => {
                        if (!enableSlug && (!slugEdited || !slugName) && portfoliocategory_name) handleSlug(portfoliocategory_name);
                        if (!isMetaTitleCustom && !meta_tag_title && portfoliocategory_name) {
                          setPortfolioCatData((prev) => ({ ...prev, meta_tag_title: portfoliocategory_name }));
                        }
                      }}
                    />
                    <div className="flex items-center justify-between mt-1 text-xs text-gray-500 w-full gap-1 min-h-[24px]">
                      <div className="flex items-center w-[90%] min-w-0">
                        <a
                          href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/${(slugName || '').toLowerCase()}`}
                          target="_blank"
                          rel="noreferrer"
                          className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 flex items-center"
                        >
                          Preview
                        </a>
                        {/* INLINE EDIT */}
                        {!enableSlug ? (
                          <div className="flex items-center gap-2 min-w-0">
                            <span className="truncate text-gray-500 min-w-0">
                              {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/${(slugName || '').toLowerCase()}`}
                            </span>

                            <button
                              type="button"
                              onClick={() => {
                                setEnableSlug(true);
                                setTimeout(() => slugInputRef.current?.focus(), 50);
                              }}
                              className="text-gray-600 hover:text-black shrink-0 flex items-center"
                            >
                              <Edit size={14} />
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-1 min-w-0 flex-1">
                            <span className="text-gray-400 shrink truncate max-w-[120px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px]">
                              {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/`}
                            </span>

                            <InputComponent
                              ref={slugInputRef}
                              name="portfolio_category_slug_name"
                              className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                              value={slugName || ''}
                              onChange={(e) => {
                                setSlugName(e.target.value);
                                setSlugEdited(Boolean(e.target.value));
                                setIsChange(true);
                              }}
                              onBlur={async () => {
                                if (slugName) {
                                  const generated = await GenerateSlugName(slugName);
                                  setSlugName(generated);
                                }
                              }}
                              onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  if (!slugName) {
                                    setIsNotification(true);
                                    setSeverity("warning");
                                    setNotificationMsg("Slug can not be empty!");
                                    return;
                                  }
                                  const generated = await GenerateSlugName(slugName);
                                  setSlugName(generated);
                                  setEnableSlug(false);
                                  setSlugEdited(true);
                                }
                              }}
                              isSlug={true}
                            />

                            <button
                              type="button"
                              className="text-green-600 ml-1 shrink-0 flex items-center"
                              onClick={async () => {
                                if (!slugName) {
                                  setIsNotification(true);
                                  setSeverity("warning");
                                  setNotificationMsg("Slug can not be empty!");
                                  return;
                                }

                                const generated = await GenerateSlugName(slugName);
                                setSlugName(generated);
                                setEnableSlug(false);
                                setSlugEdited(true);
                              }}
                            >
                              <Check size={14} />
                            </button>
                          </div>
                        )}
                      </div>

                      <span className={`shrink-0 text-end w-[10%] flex items-center justify-end ${(portfoliocategory_name?.length || 0) > 60 ? 'text-red-500 font-semibold' : ''}`}>
                        {portfoliocategory_name?.length || 0}/60
                      </span>
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="parentCategory">{t("lang_Parent_Portfolio_Category")}</label>
                    <SelectComponent
                      name="SelectedPortfolioParentCategory"
                      placeholder="Select parent category"
                      value={SelectedPortfolioParentCategory}
                      options={
                        ParentCategory
                          ? ParentCategory.map((c) => ({
                            value: c._id,
                            label: c.parent_category || c.portfoliocategory_name,
                          }))
                          : []
                      }
                      onChange={(e) => {
                        setSelectedPortfolioParentCategory(e.target.value);
                        setIsChange(true);
                      }}
                      isClearable={false}
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="description" className="block mb-1">{t("lang_description")}</label>
                    <RichTextEditor
                      htmlData={description}
                      setHtmlData={handleQuillChange}
                      uplaodImageFile={uploadTextEditorImage}
                    />
                    <div className="w-full flex justify-end mt-1">
                      <p className="text-xs text-gray-400">
                        {`${description?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                      </p>
                    </div>
                  </div>
                </DetailsComponent>

                <DetailsComponent
                  title={t("lang_search_engine_listing")}
                  subtitle={t("lang_search_engine_listing_detail")}
                  contentClassName="px-4 sm:px-[25px] pb-4 sm:pb-[25px]"
                >

                  <div className="mb-4">
                    <AiTextGenerate
                      fieldLabel={t("lang_meta_title")}
                      label={t("lang_get_meta_title")}
                      tooltip={t("lang_meta_tooltip", { type: "title" })}
                      onGenerate={() => generateMetaData(description || portfoliocategory_name, "title")}
                    />
                    <InputComponent
                      id="Meta Tag Title"
                      name="meta_tag_title"
                      value={meta_tag_title}
                      onChange={HandleInput}
                      placeholder="Enter meta title"
                    />
                    <div className="flex w-full justify-end mt-1">
                      <p className={`text-xs mt-0 ${(meta_tag_title?.length || 0) > 60 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                        {`${meta_tag_title?.length || 0}/60`}
                      </p>
                    </div>
                  </div>

                  <div className="mb-4">
                    <AiTextGenerate
                      fieldLabel={t("lang_meta_description")}
                      label={t("lang_get_meta_description")}
                      tooltip={t("lang_meta_tooltip", { type: "description" })}
                      onGenerate={() => generateMetaData(description, "description")}
                    />
                    <textarea
                      className="w-full h-24 block px-3 py-2 border border-[var(--border-color)] rounded-lg focus:outline-none focus:border-[var(--focus-border-color)] bg-[var(--secondary-bg-color)] text-[var(--primary-text-color)] text-sm"
                      id="Meta Tag description"
                      name="meta_tag_description"
                      value={(meta_tag_description || '').replace(/<[^>]+>/g, '')}
                      onChange={HandleInput}
                      placeholder="Enter meta description"
                    />
                    <div className="flex w-full justify-end mt-1">
                      <p className={`text-xs mt-0 ${((meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0) > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                        {`${(meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0}/160 words`}
                      </p>
                    </div>
                  </div>

                  <div>
                    <InputComponent
                      id="keyword"
                      name="keyword"
                      label={t("lang_meta_keywords")}
                      value={keyword}
                      onChange={HandleInput}
                      placeholder="e.g. Portfolio showcase"
                    />
                  </div>
                </DetailsComponent>
              </form>
            )}
          </div>
        </div>
      )}

      <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-4 left-0">
        <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex items-center justify-between">
          <ButtonComponent
            variant="link"
            icon={<ArrowLeft className="w-3 h-3" />}
            onClick={(e) => {
              e.preventDefault();
              checkChanges();
            }}
            className="text-[var(--table-text-color)]"
          >
            {t("lang_Go_To_Portfolio_Categories")}
          </ButtonComponent>
          <div>
            {portfoliocategory_name === "" || enableSlug ? (
              <ButtonComponent variant="primary" disabled>
                {t("lang_Save_Changes")}
              </ButtonComponent>
            ) : (
              <ButtonComponent
                variant="primary"
                loading={btnLoading}
                onClick={(e) => HandleSubmit(e)}
              >
                {t("lang_Save_Changes")}
              </ButtonComponent>
            )}
          </div>
        </div>
      </div>

      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
    </>
  );
}

export default UpdatePortfolioCategory;
